import SettingsTab from './SettingsTab';
import pageMeta from './page-settings/page-meta';
import pageBasic from './page-settings/page-basic';
import advancedPageSettings from './page-settings/advanced-page-settings';

export default [
    new SettingsTab({
        title: 'Basic',
        icon: ['far', 'bars'],
        content: pageBasic,
    }),
    new SettingsTab({
        icon: ['far', 'plug'],
        title: 'Page Meta',
        content: pageMeta,
    }),
    new SettingsTab({
        title: 'Advanced',
        content: advancedPageSettings,
        icon: ['far', 'laptop-code'],
    }),
];
